import { render, staticRenderFns } from "./LuckNumber.vue?vue&type=template&id=7bb007b6&scoped=true"
import script from "./LuckNumber.vue?vue&type=script&lang=js"
export * from "./LuckNumber.vue?vue&type=script&lang=js"
import style0 from "./LuckNumber.vue?vue&type=style&index=0&id=7bb007b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb007b6",
  null
  
)

export default component.exports